import {
  AssociadoSearchResponse,
  AssociadoUpdateRequest,
} from 'api/Assessor/associado';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import PageTitle from 'components/__SHARED__/PageTitle/PageTitle';
import Page from 'components/__SHARED__/PrivateContainer';
import translation from 'locales/translation';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from 'store/Reducer';
import Pesquisa from './Pesquisa';
import Tabela from './Tabela';
import useStyle from './style';

export default function Assessor() {
  const classes = useStyle();
  const { atualizandoAssociado, procurandoAssociado } = useSelector(
    (state: IReducer) => state.assessor
  );
  const [lista, setLista] = useState<AssociadoSearchResponse>();

  const atualizaLista = useCallback(
    (changes: AssociadoUpdateRequest) => {
      const _lista = Array.from(lista || []);
      const found = _lista.findIndex(
        (associado) => associado.id === changes.oidAssociado
      );
      if (found >= 0) {
        _lista[found].flgColaborador = changes.flgColaborador;
        setLista(_lista);
      }
    },
    [lista]
  );

  return (
    <Page
      header={<PageTitle title={translation.VinculoAssociado.title} />}
      headerClassName={classes.header}
    >
      <Pesquisa onSearchResult={setLista} />
      {lista && <Tabela associados={lista} onChangeItem={atualizaLista} />}
      {(atualizandoAssociado || procurandoAssociado) && (
        <Loading
          text={
            translation.VinculoAssociado[
              atualizandoAssociado
                ? 'atualizandoAssociado'
                : 'procurandoAssociado'
            ]
          }
        />
      )}
    </Page>
  );
}
